import {
  faEnvelopeOpenText,
  faShare,
  faSliders,
} from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';

import {
  Button,
  ButtonLink,
  CopyLink,
  Dropdown,
} from 'apps/shared/scripts/components';

import {
  buttonClassName,
  iconClassName,
  menuClassName,
  rightHeaderClassName,
} from './styles';

interface Props {
  cardId: string;
  isDelivered?: boolean;
}

const RightHeader = ({ cardId, isDelivered }: Props) => {
  const [isOpen, setOpen] = useState<boolean>(false);

  return (
    <div className={rightHeaderClassName}>
      <ButtonLink
        className={buttonClassName}
        iconClassName={iconClassName}
        faIcon={faSliders}
        to={`/dashboard/cards/${cardId}`}
        mobileIconOnly
      >
        Manage
      </ButtonLink>
      {!isDelivered && (
        <ButtonLink
          className={buttonClassName}
          iconClassName={iconClassName}
          faIcon={faEnvelopeOpenText}
          to={`/dashboard/cards/${cardId}/delivery`}
          mobileIconOnly
        >
          Send
        </ButtonLink>
      )}
      <Dropdown
        button={
          <Button
            className={buttonClassName}
            iconClassName={iconClassName}
            faIcon={faShare}
            mobileIconOnly
          >
            Share
          </Button>
        }
        menuClassName={menuClassName}
        isOpen={isOpen}
        setOpen={setOpen}
      >
        <CopyLink
          onCopy={() => setOpen(false)}
          url={`${process.env.REACT_APP_URL!}/${cardId}`}
        />
      </Dropdown>
    </div>
  );
};

RightHeader.displayName = 'RightHeader';

export default RightHeader;
